module.exports = __webpack_public_path__ + "img/banner-mobile.c13b91c5.png";